(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('ocn-about');
  if (!root) return;

  // Piliers : pop-up détaillé au clic
  var modal = document.getElementById('ocn-about-modal');
  if (modal) {
    var mTitle = modal.querySelector('[data-modal-title]');
    var mBody = modal.querySelector('[data-modal-body]');
    var mEyebrow = modal.querySelector('[data-modal-eyebrow]');
    var closeModal = function(){ modal.hidden = true; document.body.style.overflow = ''; };
    root.querySelectorAll('[data-pillar-open]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var card = btn.closest('.ocn-about__value');
        var titleEl = card.querySelector('.ocn-about__value-title');
        var detailEl = card.querySelector('.ocn-about__value-detail');
        if (mTitle && titleEl) mTitle.textContent = titleEl.textContent;
        if (mBody) mBody.innerHTML = detailEl ? detailEl.innerHTML : '';
        if (mEyebrow) mEyebrow.textContent = 'Pilier OCENEO';
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });
    modal.querySelectorAll('[data-pillar-close]').forEach(function(el){ el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hidden) closeModal(); });
  }

  // Frise : glissement horizontal au clic sur l'année
  var tl = document.getElementById('ocn-about-timeline');
  if (tl) {
    var track = document.getElementById('ocn-about-track');
    var years = tl.querySelectorAll('.ocn-about__axis-year');
    var panels = track ? track.querySelectorAll('.ocn-about__panel') : [];
    var isMobile = function(){ return window.matchMedia('(max-width: 768px)').matches; };
    function setActive(i){ years.forEach(function(o){ o.classList.toggle('is-active', parseInt(o.dataset.index, 10) === i); }); }
    years.forEach(function(y){
      y.addEventListener('click', function(){
        var i = parseInt(y.dataset.index, 10);
        setActive(i);
        if (isMobile()) {
          if (panels[i]) panels[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        } else if (track) {
          track.style.transform = 'translateX(-' + (i * 100) + '%)';
        }
      });
    });
    // Mobile : l'année active suit le défilement au doigt
    if (track) {
      var arTk;
      track.addEventListener('scroll', function(){
        if (!isMobile()) return;
        clearTimeout(arTk);
        arTk = setTimeout(function(){
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          setActive(idx);
        }, 60);
      }, { passive: true });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-element"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('.add').forEach(item => {
        item.addEventListener('click', event => {
            const quantityDisplay = item.previousElementSibling.querySelector('span');
            const quantity = item.previousElementSibling.querySelector('.item_quantity');

            quantityDisplay.textContent = parseInt(quantityDisplay.textContent) + 1;
            quantity.value = parseInt(quantityDisplay.textContent);
        });
    });

    // Cart note toggle + char counter
    (function(){
        var card = document.querySelector('.ocn-cart-note');
        if (!card) return;
        var toggle = card.querySelector('.ocn-cart-note__toggle');
        var textarea = card.querySelector('textarea');
        var counter = card.querySelector('[data-count]');
        function updateCount(){
            if (counter && textarea) counter.textContent = textarea.value.length;
        }
        updateCount();
        toggle.addEventListener('click', function(){
            var open = card.getAttribute('data-open') === 'true';
            card.setAttribute('data-open', open ? 'false' : 'true');
            toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
            if (!open) setTimeout(function(){ textarea && textarea.focus(); }, 280);
        });
        if (textarea) textarea.addEventListener('input', updateCount);
    })();

    document.querySelectorAll('.sub').forEach(item => {
        item.addEventListener('click', event => {
            const quantityDisplay = item.nextElementSibling.querySelector('span');
            const quantity = item.nextElementSibling.querySelector('.item_quantity');

            if (parseInt(quantityDisplay.textContent) > 1) {
                quantityDisplay.textContent = parseInt(quantityDisplay.textContent) - 1;
                quantity.value = parseInt(quantityDisplay.textContent);
            }
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Aperçu coloris sur les cartes boutique : survol/clic d'une pastille = la carte montre ce coloris.
  // Le clic sur la pastille n'ouvre pas le produit (preventDefault) ; cliquer ailleurs sur la carte y mène.
  document.querySelectorAll('.ocn-pcard').forEach(function(card){
    var img = card.querySelector('img.ocn-pcard__img');
    if (!img) return;
    var orig = img.getAttribute('src');
    var hover = card.getAttribute('data-hover-img'); // photo mannequin
    var sws = card.querySelectorAll('.ocn-pcard__sw[data-card-img]');
    function reset(){ img.setAttribute('src', orig); sws.forEach(function(s){ s.classList.remove('is-active'); }); }
    // Survol de la carte → photo mannequin (si disponible)
    if (hover) {
      card.addEventListener('mouseenter', function(){ img.setAttribute('src', hover); });
    }
    // Survol/clic d'une pastille → aperçu du coloris (prioritaire sur le mannequin)
    sws.forEach(function(sw){
      var src = sw.getAttribute('data-card-img');
      function preview(){ img.setAttribute('src', src); sws.forEach(function(s){ s.classList.remove('is-active'); }); sw.classList.add('is-active'); }
      sw.addEventListener('mouseenter', preview);
      sw.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); preview(); });
      sw.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); preview(); } });
    });
    card.addEventListener('mouseleave', reset);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-bestsellers"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.getElementById('ocn-best');
  if (!root) return;
  const tabs = root.querySelectorAll('.ocn-best__tab');
  const panels = root.querySelectorAll('.ocn-best__panel');
  tabs.forEach(t => t.addEventListener('click', () => {
    tabs.forEach(x=>x.classList.remove('is-active')); t.classList.add('is-active');
    panels.forEach(p=>p.classList.toggle('is-hidden', p.dataset.coll !== t.dataset.coll));
  }));
  root.querySelectorAll('.ocn-best__arrow').forEach(a => a.addEventListener('click', () => {
    const panel = root.querySelector('.ocn-best__panel:not(.is-hidden) .ocn-best__track');
    if (!panel) return;
    const card = panel.querySelector('.ocn-pcard');
    const w = card ? card.offsetWidth + 18 : 320;
    panel.scrollBy({ left: parseInt(a.dataset.dir,10) * w, behavior: 'smooth' });
  }));

  // Survol carte → photo mannequin (si disponible)
  root.querySelectorAll('.ocn-pcard').forEach(function(card){
    var img = card.querySelector('img.ocn-pcard__img');
    var hover = card.getAttribute('data-hover-img');
    if (!img || !hover) return;
    var orig = img.getAttribute('src');
    card.addEventListener('mouseenter', function(){ img.setAttribute('src', hover); });
    card.addEventListener('mouseleave', function(){ img.setAttribute('src', orig); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-colorways"] && !Shopify.designMode) return;
  try {
    
(function(){
  const c = document.getElementById('ocn-compare');
  if (!c) return;
  let dragging = false;
  function setPos(clientX){
    const r = c.getBoundingClientRect();
    let p = ((clientX - r.left) / r.width) * 100;
    p = Math.max(3, Math.min(97, p));
    c.style.setProperty('--pos', p + '%');
  }
  c.addEventListener('pointerdown', e => { dragging = true; setPos(e.clientX); });
  window.addEventListener('pointermove', e => { if (dragging) setPos(e.clientX); });
  window.addEventListener('pointerup', () => { dragging = false; });
  c.addEventListener('pointerleave', () => {});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-configurator"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('ocn-conf');
  if (!root) return;

  // Anim trait orange au scroll
  var hl = root.querySelector('.ocn-conf__hl');
  if (hl){
    if ('IntersectionObserver' in window){
      var o = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-drawn'); o.unobserve(e.target); } }); }, { threshold: 0.4 });
      var r = hl.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.8) { setTimeout(function(){ hl.classList.add('is-drawn'); }, 250); }
      else o.observe(hl);
    } else hl.classList.add('is-drawn');
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('ocn-featured-root');
  if (!root) return;
  var dataEl = document.getElementById('ocn-featured-data');
  var selEl = document.getElementById('ocn-featured-selected');
  if (!dataEl) return;

  var variants = JSON.parse(dataEl.textContent || '[]');
  var selected = selEl ? JSON.parse(selEl.textContent || '[]') : [];

  var mainImg = document.getElementById('ocn-featured-img');
  var vidInput = document.getElementById('ocn-featured-vid');
  var priceEl = document.getElementById('ocn-featured-price');
  var addPriceEl = document.getElementById('ocn-featured-add-price');
  var addBtn = document.getElementById('ocn-featured-add');
  var addLabel = document.getElementById('ocn-featured-add-label');
  var buynow = document.getElementById('ocn-featured-buynow');
  var qty = document.getElementById('ocn-featured-qty');

  function findVariant(){
    return variants.find(function(v){
      return v.opts.length === selected.length && v.opts.every(function(o, i){ return o === selected[i]; });
    });
  }

  // Galerie mosaïque pilotée par les boutons (comme la fiche produit) — regroupe par ALT "Pigment / Verre"
  var gallery = document.getElementById('ocn-featured-gallery');
  var allMedia = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('.ocn-featured__media[data-img-id]')) : [];
  function mediaSrc(m){ var i = m.querySelector('img'); return i ? (i.getAttribute('src') || '') : ''; }
  function isModelMedia(m){
    var a = (m.getAttribute('data-alt') || '').toLowerCase(); var s = mediaSrc(m).toLowerCase();
    return a.indexOf('model') > -1 || a.indexOf('mannequin') > -1 || s.indexOf('mannequin') > -1;
  }
  function isColisMedia(m){ return m.getAttribute('data-colis') === '1'; }
  function angleRank(m){
    if (isColisMedia(m)) return 3.5;
    if (isModelMedia(m)) return 4;
    var s = mediaSrc(m).toLowerCase();
    if (s.indexOf('face') > -1) return 1;
    if (s.indexOf('demi') > -1 || s.indexOf('3-4') > -1) return 2;
    if (s.indexOf('cote') > -1 || s.indexOf('côté') > -1) return 3;
    return 2.5;
  }
  // Affiche la déclinaison choisie via les boutons : face en grand (lead) + tuiles rangées (face → demi → côté → mannequin)
  function applyGroup(){
    if (!allMedia.length) return;
    var groupAlt = (selected.length >= 2 && selected[0] && selected[1]) ? (selected[0] + ' / ' + selected[1]) : '';
    var matches = groupAlt ? allMedia.filter(function(m){ return (m.getAttribute('data-alt') || '') === groupAlt; }) : [];
    var models = allMedia.filter(isModelMedia);
    var colis = allMedia.filter(isColisMedia);
    var show;
    if (matches.length) {
      colis.forEach(function(m){ if (matches.indexOf(m) < 0) matches.push(m); });
      models.forEach(function(m){ if (matches.indexOf(m) < 0) matches.push(m); });
      show = matches;
    }
    else if (models.length) { show = models.slice(); }
    else { show = allMedia.slice(); }
    show.sort(function(a, b){ return angleRank(a) - angleRank(b); });
    allMedia.forEach(function(m){ m.classList.toggle('ocn-featured__media--hidden', show.indexOf(m) < 0); m.classList.remove('ocn-featured__media--lead'); });
    show.forEach(function(m){ gallery.appendChild(m); });
    if (show[0]) show[0].classList.add('ocn-featured__media--lead');
  }

  function update(){
    var v = findVariant();
    if (!v) return;
    if (vidInput) vidInput.value = v.id;
    if (priceEl) priceEl.textContent = v.price_fmt;
    if (addPriceEl) addPriceEl.textContent = v.price_fmt;
    if (addBtn) { addBtn.disabled = !v.available; }
    if (addLabel && addBtn) { addLabel.textContent = v.available ? (addBtn.dataset.i18nAdd || 'Ajouter au panier') : (addBtn.dataset.i18nSoldout || 'Rupture de stock'); }
    if (addPriceEl) { addPriceEl.style.display = v.available ? '' : 'none'; }
    applyGroup();
  }

  // Sélection des options (pastilles)
  root.querySelectorAll('.ocn-pdp__value').forEach(function(btn){
    btn.addEventListener('click', function(){
      var oi = parseInt(btn.dataset.option, 10);
      selected[oi] = btn.dataset.value;
      var group = btn.closest('.ocn-pdp__values');
      group.querySelectorAll('.ocn-pdp__value').forEach(function(b){ b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var lbl = root.querySelector('[data-selected-value="' + oi + '"]');
      if (lbl) lbl.textContent = btn.dataset.value;
      update();
    });
  });

  // Quantité
  var minus = document.getElementById('ocn-featured-qty-minus');
  var plus = document.getElementById('ocn-featured-qty-plus');
  if (minus) minus.addEventListener('click', function(){ qty.value = Math.max(1, parseInt(qty.value||1,10) - 1); });
  if (plus) plus.addEventListener('click', function(){ qty.value = parseInt(qty.value||1,10) + 1; });

  // (Les miniatures ne sont plus cliquables : ce sont les boutons de variante qui pilotent l'affichage.)

  // Acheter maintenant → ajoute puis checkout
  if (buynow) buynow.addEventListener('click', function(){
    var vid = vidInput ? vidInput.value : null;
    var q = qty ? Math.max(1, parseInt(qty.value || 1, 10)) : 1;
    if (!vid) return;
    buynow.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: q }] })
    }).then(function(r){ return r.json(); }).then(function(){ window.location.href = '/checkout'; })
      .catch(function(){ buynow.classList.remove('is-loading'); });
  });

  // Le bouton "Ajouter au panier" (submit du form /cart/add) est intercepté
  // par le mini-panier global (ocn-cart-drawer) qui ouvre le tiroir.

  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-lifestyle-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  const video = document.querySelector('#ocn-sculpted .ocn-sculpted__video');
  const btn = document.getElementById('ocn-sculpted-pause');
  if (!video || !btn) return;
  const pauseIcon = btn.querySelector('.ocn-pause-icon');
  const playIcon = btn.querySelector('.ocn-play-icon');
  btn.addEventListener('click', () => {
    if (video.paused) {
      video.play();
      pauseIcon.style.display = '';
      playIcon.style.display = 'none';
    } else {
      video.pause();
      pauseIcon.style.display = 'none';
      playIcon.style.display = '';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  const hero = document.getElementById('ocn-hero');
  if (!hero) return;
  const track = document.getElementById('ocn-hero-track');
  const slides = track ? track.querySelectorAll('.ocn-hero__slide') : [];
  const dots = hero.querySelectorAll('.ocn-hero__dot');
  const prev = document.getElementById('ocn-hero-prev');
  const next = document.getElementById('ocn-hero-next');
  if (slides.length <= 1) return;

  let i = 0;
  let timer = null;
  const autoplay = hero.dataset.autoplay === 'true';
  const speed = parseInt(hero.dataset.speed, 10) || 6000;

  function go(n) {
    i = (n + slides.length) % slides.length;
    track.style.setProperty('--hero-i', i);
    dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
  }
  function start() { if (autoplay) { stop(); timer = setInterval(() => go(i + 1), speed); } }
  function stop() { if (timer) clearInterval(timer); }

  if (prev) prev.addEventListener('click', () => { go(i - 1); start(); });
  if (next) next.addEventListener('click', () => { go(i + 1); start(); });
  dots.forEach(d => d.addEventListener('click', () => { go(parseInt(d.dataset.index, 10)); start(); }));

  hero.addEventListener('mouseenter', stop);
  hero.addEventListener('mouseleave', start);

  // Swipe tactile (mobile)
  var tsX = 0, tsY = 0, swiping = false;
  var vp = hero.querySelector('.ocn-hero__viewport') || hero;
  vp.addEventListener('touchstart', function(e){ var t = e.changedTouches[0]; tsX = t.clientX; tsY = t.clientY; swiping = true; stop(); }, { passive: true });
  vp.addEventListener('touchend', function(e){
    if (!swiping) return; swiping = false;
    var t = e.changedTouches[0];
    var dx = t.clientX - tsX, dy = t.clientY - tsY;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { go(dx < 0 ? i + 1 : i - 1); }
    start();
  }, { passive: true });

  start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-quote"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.getElementById('ocn-quote');
  if (!root) return;
  const slides = root.querySelectorAll('.ocn-quote__slide');
  const dots = root.querySelectorAll('.ocn-quote__dot');
  if (slides.length <= 1) return;
  let i = 0, timer = null;
  const autoplay = root.dataset.autoplay === 'true';
  function go(n){ i = (n + slides.length) % slides.length; slides.forEach((s,k)=>s.classList.toggle('is-active',k===i)); dots.forEach((d,k)=>d.classList.toggle('is-active',k===i)); }
  function start(){ if (autoplay){ stop(); timer = setInterval(()=>go(i+1), 6000); } }
  function stop(){ if (timer) clearInterval(timer); }
  dots.forEach(d => d.addEventListener('click', () => { go(parseInt(d.dataset.index,10)); start(); }));
  root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
  start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
(function(){
  document.querySelectorAll('.ocn-search .ocn-pcard[data-hover-img]').forEach(function(card){
    var img = card.querySelector('img.ocn-pcard__img');
    if (!img) return;
    var orig = img.getAttribute('src');
    var hover = card.getAttribute('data-hover-img');
    card.addEventListener('mouseenter', function(){ img.setAttribute('src', hover); });
    card.addEventListener('mouseleave', function(){ img.setAttribute('src', orig); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navbar"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Dropdowns langue / devise
  const dds = document.querySelectorAll('[data-dd]');
  dds.forEach(dd => {
    const toggle = dd.querySelector('[data-dd-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = dd.classList.contains('is-open');
      dds.forEach(d => { d.classList.remove('is-open'); const t = d.querySelector('[data-dd-toggle]'); if (t) t.setAttribute('aria-expanded', 'false'); });
      if (!isOpen) { dd.classList.add('is-open'); toggle.setAttribute('aria-expanded', 'true'); }
    });
  });
  document.addEventListener('click', () => {
    dds.forEach(d => { d.classList.remove('is-open'); const t = d.querySelector('[data-dd-toggle]'); if (t) t.setAttribute('aria-expanded', 'false'); });
  });

  // Menu mobile
  const burger = document.getElementById('ocn-burger');
  const mobile = document.getElementById('ocn-mobile');
  const close = document.getElementById('ocn-mobile-close');
  const overlay = mobile ? mobile.querySelector('.ocn-mobile__overlay') : null;
  function openM() { mobile.classList.add('is-open'); mobile.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; document.body.classList.add('ocn-menu-open'); }
  function closeM() { mobile.classList.remove('is-open'); mobile.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; document.body.classList.remove('ocn-menu-open'); }
  if (burger) burger.addEventListener('click', openM);
  if (close) close.addEventListener('click', closeM);
  if (overlay) overlay.addEventListener('click', closeM);

  // Trigger dropdown desktop : ne pas naviguer si url = "#"
  document.querySelectorAll('.ocn-nav-dd__trigger').forEach(t => {
    t.addEventListener('click', e => {
      const href = t.getAttribute('href');
      if (!href || href === '#' || href.slice(-1) === '#') e.preventDefault();
    });
  });

  // Accordéon menu mobile
  document.querySelectorAll('[data-acc]').forEach(btn => {
    const panel = btn.nextElementSibling;
    btn.addEventListener('click', () => {
      const open = btn.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
    });
  });

  // Header sticky : reste visible et suit le scroll ; ombre dès qu'on défile (desktop + mobile)
  const header = document.getElementById('ocn-header');
  if (header) {
    let ticking = false;
    function onScroll() {
      const y = window.pageYOffset || document.documentElement.scrollTop || 0;
      header.classList.toggle('ocn-header--scrolled', y > 4);
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neopop"] && !Shopify.designMode) return;
  try {
    
(function(){
  var rail = document.getElementById('ocn-neo-carousel');
  if (!rail) return;
  var down = false, startX = 0, startScroll = 0, moved = false;
  rail.addEventListener('mousedown', function(e){
    down = true; moved = false; startX = e.pageX; startScroll = rail.scrollLeft;
  });
  window.addEventListener('mousemove', function(e){
    if (!down) return;
    var dx = e.pageX - startX;
    if (Math.abs(dx) > 4) { moved = true; rail.classList.add('is-dragging'); }
    rail.scrollLeft = startScroll - dx;
  });
  window.addEventListener('mouseup', function(){
    down = false;
    setTimeout(function(){ rail.classList.remove('is-dragging'); }, 50);
  });
  // Empêche le clic fantôme après un drag
  rail.addEventListener('click', function(e){ if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
})();

// Vidéo process : façade lazy — l'iframe ne se charge qu'au clic
(function(){
  document.querySelectorAll('.ocn-neo__video-facade').forEach(function(btn){
    btn.addEventListener('click', function(){
      var src = btn.getAttribute('data-embed');
      if (!src) return;
      var ifr = document.createElement('iframe');
      ifr.setAttribute('src', src);
      ifr.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      ifr.setAttribute('allowfullscreen', '');
      ifr.setAttribute('title', 'Vidéo du procédé OCENEO');
      btn.replaceWith(ifr);
    });
  });
})();

// Visionneuses 3D : façade — la librairie model-viewer et le fichier .glb ne se chargent qu'au clic
(function(){
  var MV_SRC = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';
  var mvRequested = false;
  function loadMV(){
    if (mvRequested || customElements.get('model-viewer') || document.querySelector('script[data-mv]')) return;
    mvRequested = true;
    var s = document.createElement('script');
    s.type = 'module';
    s.src = MV_SRC;
    s.setAttribute('data-mv', '');
    document.head.appendChild(s);
  }
  document.querySelectorAll('.ocn-neo__tile-3d[data-model]').forEach(function(btn){
    btn.addEventListener('click', function(){
      if (btn.dataset.loaded) return;
      btn.dataset.loaded = '1';
      loadMV();
      var poster = btn.querySelector('.ocn-neo__tile-img, .ocn-neo__texture');
      var mv = document.createElement('model-viewer');
      mv.className = 'ocn-neo__tile-img ocn-neo__tile-model';
      mv.setAttribute('src', btn.getAttribute('data-model'));
      mv.setAttribute('alt', btn.getAttribute('data-alt') || 'Modèle 3D');
      mv.setAttribute('camera-controls', '');
      mv.setAttribute('auto-rotate', '');
      mv.setAttribute('rotation-per-second', '22deg');
      mv.setAttribute('interaction-prompt', 'none');
      mv.setAttribute('touch-action', 'pan-y');
      mv.setAttribute('shadow-intensity', '0.7');
      mv.setAttribute('exposure', '1.05');
      mv.setAttribute('reveal', 'auto');
      btn.insertBefore(mv, btn.firstChild);
      if (poster) poster.remove();
      btn.classList.add('is-3d-active');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocn-process-video"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.ocn-pvid__facade').forEach(function(btn){
    btn.addEventListener('click', function(){
      var src = btn.getAttribute('data-video');
      if (!src) return;
      var v = document.createElement('video');
      v.className = 'ocn-pvid__video';
      v.setAttribute('src', src);
      v.setAttribute('controls', '');
      v.setAttribute('autoplay', '');
      v.muted = true; v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      btn.replaceWith(v);
      var p = v.play(); if (p && p.catch) { p.catch(function(){}); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.getElementById('ocn-pdp');
  if (!root) return;
  const dataEl = document.getElementById('ocn-pdp-variants');
  let variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch(e){}
  const idInput = document.getElementById('ocn-pdp-variant-id');
  const priceEl = document.getElementById('ocn-pdp-price');
  const addPriceEl = document.getElementById('ocn-pdp-add-price');
  const addBtn = document.getElementById('ocn-pdp-add');
  const addLabel = document.getElementById('ocn-pdp-add-label');
  const money = (cents) => { try { return (cents/100).toLocaleString('fr-FR',{minimumFractionDigits:2,maximumFractionDigits:2})+' €'; } catch(e){ return (cents/100).toFixed(2)+' €'; } };

  // Etat des options
  let selected = [];
  root.querySelectorAll('.ocn-pdp__option').forEach((optEl, i) => {
    const active = optEl.querySelector('.ocn-pdp__value.is-active');
    selected[i] = active ? active.dataset.value : null;
  });

  function findVariant(){
    return variants.find(v => v.options.every((o, i) => o === selected[i]));
  }

  // Galerie : on regroupe les images par leur ALT ("Coloris / Verres").
  // Au changement de variante, on n'affiche que les vues de la déclinaison choisie.
  const gallery = document.getElementById('ocn-pdp-gallery');
  const allMedia = gallery ? Array.from(gallery.querySelectorAll('.ocn-pdp__media[data-img-id]')) : [];

  function mediaSrc(m){ var i = m.querySelector('img'); return i ? (i.getAttribute('src') || '') : ''; }
  function isModelMedia(m){ var a = (m.dataset.alt || '').toLowerCase(); var s = mediaSrc(m).toLowerCase(); return a.indexOf('model') > -1 || a.indexOf('mannequin') > -1 || s.indexOf('mannequin') > -1; }
  function isColisMedia(m){ return m.dataset.colis === '1'; }
  // Ordre fixe : 1 face · 2 demi (¾) · 3 côté · 3.5 colis (ce qui est inclus) · 4-5 mannequin
  function angleRank(m){
    if (isColisMedia(m)) return 3.5;
    if (isModelMedia(m)) return 4;
    var s = mediaSrc(m).toLowerCase();
    if (s.indexOf('face') > -1) return 1;
    if (s.indexOf('demi') > -1 || s.indexOf('3-4') > -1 || s.indexOf('trois-quart') > -1) return 2;
    if (s.indexOf('cote') > -1 || s.indexOf('côté') > -1) return 3;
    return 2.5;
  }
  function applyGroup(v){
    if (!gallery || !allMedia.length) return;
    // Groupe = "Pigment / Verre" à partir des options sélectionnées (robuste, n'exige pas d'image assignée à la variante)
    // Comparaison normalisée (trim + minuscules + espaces) : robuste aux différences de casse FR/EN/ES…
    var norm = function(s){ return (s || '').trim().toLowerCase().replace(/\s+/g,' '); };
    var groupAlt = (selected.length >= 2 && selected[0] && selected[1]) ? norm(selected[0] + ' / ' + selected[1]) : '';
    var matches = groupAlt ? allMedia.filter(m => norm(m.dataset.alt) === groupAlt) : [];
    var models = allMedia.filter(isModelMedia);
    var colis = allMedia.filter(isColisMedia);
    // Photos mannequin + photo colis : toujours visibles dans la dérivation choisie
    if (matches.length) {
      colis.forEach(m => { if (matches.indexOf(m) < 0) matches.push(m); });
      models.forEach(m => { if (matches.indexOf(m) < 0) matches.push(m); });
    }
    // Filet de sécurité : aucune correspondance (ex. alt non traduit dans une langue, ou coloris
    // sans photo dédiée) → on affiche TOUTES les montures + mannequins. Jamais une galerie sans lunettes.
    var show;
    if (matches.length) { show = matches; }
    else {
      var frames = allMedia.filter(function(m){ return !isModelMedia(m) && !isColisMedia(m); });
      if (frames.length) { show = frames.concat(models); }
      else if (models.length) { show = models.slice(); }
      else { show = allMedia.length ? [allMedia[0]] : []; }
    }
    // Tri : face → demi → côté → mannequins · la vidéo passe toujours en dernier
    function finalRank(m){ return m.dataset.pvideo === '1' ? 9 : angleRank(m); }
    show.sort(function(a, b){ return finalRank(a) - finalRank(b); });
    var showSet = new Set(show);
    allMedia.forEach(m => {
      m.classList.toggle('ocn-pdp__media--hidden', !showSet.has(m));
      m.classList.remove('ocn-pdp__media--lead');
    });
    // Réordonne le DOM dans l'ordre voulu
    show.forEach(function(m){ gallery.appendChild(m); });
    if (show[0]) show[0].classList.add('ocn-pdp__media--lead');
  }

  function update(){
    const v = findVariant();
    if (!v) {
      if (addBtn){ addBtn.disabled = true; addLabel.textContent = (addBtn.dataset.paused === '1') ? (addBtn.dataset.i18nSoldout || 'Rupture de stock') : (addBtn.dataset.i18nUnavail || 'Indisponible'); }
      return;
    }
    if (idInput) idInput.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (addPriceEl) addPriceEl.textContent = money(v.price);
    if (addBtn){ if (addBtn.dataset.paused === '1'){ addBtn.disabled = true; addLabel.textContent = addBtn.dataset.i18nSoldout || 'Rupture de stock'; } else { addBtn.disabled = !v.available; addLabel.textContent = v.available ? (addBtn.dataset.i18nAdd || 'Ajouter au panier') : (addBtn.dataset.i18nSoldout || 'Rupture de stock'); } }
    var sp = document.getElementById('ocn-pdp-sticky-price'); if (sp) sp.textContent = money(v.price);
    var so = document.getElementById('ocn-pdp-sticky-opts'); if (so && v.title && v.title !== 'Default Title') so.textContent = v.title;
    applyGroup(v);
  }

  // Filtrage initial selon la variante affichée au chargement
  applyGroup(findVariant());

  root.querySelectorAll('.ocn-pdp__value').forEach(btn => {
    btn.addEventListener('click', () => {
      const oi = parseInt(btn.dataset.option, 10);
      selected[oi] = btn.dataset.value;
      const group = btn.closest('.ocn-pdp__values');
      group.querySelectorAll('.ocn-pdp__value').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const lbl = root.querySelector('[data-selected-value="'+oi+'"]');
      if (lbl) lbl.textContent = btn.dataset.value;
      update();
    });
  });

  // Quantité
  const qty = document.getElementById('ocn-pdp-qty');
  const minus = document.getElementById('ocn-pdp-qty-minus');
  const plus = document.getElementById('ocn-pdp-qty-plus');
  if (minus) minus.addEventListener('click', () => { qty.value = Math.max(1, parseInt(qty.value||1,10) - 1); });
  if (plus) plus.addEventListener('click', () => { qty.value = parseInt(qty.value||1,10) + 1; });

  // Essayage virtuel (Glasson) — on cible le bouton "ESSAYEZ" (caméra/AR),
  // surtout PAS le bouton "VUE 360" (3D).
  const tryon = document.getElementById('ocn-pdp-tryon');
  function findGlassonTryon(){
    // 1) Sélecteurs explicites essayage / caméra / live
    var direct = ['[class*="glasson"] [class*="tryon"]','[class*="glasson"] [class*="try-on"]','[class*="glasson"] [class*="live"]','[class*="glasson"] [class*="camera"]','.glasson-tryon','.glasson-btn-tryon','.glasson-btn-live'];
    for (var i=0;i<direct.length;i++){ var d=document.querySelector(direct[i]); if(d) return d; }
    // 2) Par le libellé : on prend "ESSAYEZ/essayer/try", on exclut "360/vue"
    var cands = document.querySelectorAll('[class*="glasson"] button, [class*="glasson"] a, button[class*="glasson"], a[class*="glasson"], [class*="glasson"] [role="button"]');
    for (var j=0;j<cands.length;j++){
      var t = (cands[j].textContent || '').trim().toLowerCase();
      if (/360|vue/.test(t)) continue;
      if (/essay|try|cam|porter|visage/.test(t)) return cands[j];
    }
    // 3) Repli : premier bouton Glasson qui n'est pas le 360
    for (var k=0;k<cands.length;k++){ if(!/360|vue/.test((cands[k].textContent||'').toLowerCase())) return cands[k]; }
    return cands[0] || null;
  }
  if (tryon) tryon.addEventListener('click', () => {
    var trigger = findGlassonTryon();
    if (trigger) trigger.click();
    else window.location.hash = 'glasson';
  });

  // Arrivée depuis "Essayer virtuellement" (home) : on ouvre l'AR automatiquement
  if (window.location.hash === '#essayer') {
    var arTries = 0;
    var arTimer = setInterval(function(){
      arTries++;
      var trigger = findGlassonTryon();
      if (trigger) { clearInterval(arTimer); trigger.click(); }
      else if (arTries > 24) { clearInterval(arTimer); } // ~12s : l'app n'a pas chargé
    }, 500);
  }

  // Acheter maintenant — ajoute au panier puis redirige vers le checkout
  const buynow = document.getElementById('ocn-pdp-buynow');
  if (buynow) buynow.addEventListener('click', () => {
    const vid = idInput ? idInput.value : null;
    const q = qty ? Math.max(1, parseInt(qty.value || 1, 10)) : 1;
    if (!vid) return;
    buynow.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: q }] })
    }).then(r => r.json()).then(() => { window.location.href = '/checkout'; })
      .catch(() => { buynow.classList.remove('is-loading'); });
  });

  // Popup avis
  const rvTrigger = document.getElementById('ocn-pdp-rating-trigger');
  const rvModal = document.getElementById('ocn-pdp-reviews-modal');
  if (rvTrigger && rvModal) {
    const openRv = () => { rvModal.hidden = false; document.body.style.overflow = 'hidden'; };
    const closeRv = () => { rvModal.hidden = true; document.body.style.overflow = ''; };
    rvTrigger.addEventListener('click', openRv);
    rvModal.querySelectorAll('[data-rv-close]').forEach(el => el.addEventListener('click', closeRv));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !rvModal.hidden) closeRv(); });
  }

  // Barre d'achat sticky — apparaît quand le bloc d'achat n'est plus visible
  const sticky = document.getElementById('ocn-pdp-sticky');
  const buybox = root.querySelector('.ocn-pdp__buybox');
  if (sticky && buybox && 'IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        const past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
      });
    }, { threshold: 0 });
    obs.observe(buybox);
  }
  const sBuy = document.getElementById('ocn-pdp-sticky-buy');
  if (sBuy && addBtn) sBuy.addEventListener('click', () => addBtn.click());

  // Autres créations : survol carte → photo mannequin
  // Date de livraison estimée (auto : aujourd'hui + fabrication + transport, formatée dans la langue de la page)
  (function(){
    var el = document.getElementById('ocn-pdp-edd');
    if (!el) return;
    var _ab = document.getElementById('ocn-pdp-add');
    if (_ab && _ab.dataset.paused === '1') return;
    if (el.dataset.preorder) { document.getElementById('ocn-pdp-edd-txt').textContent = el.dataset.preorder; el.hidden = false; return; }
    try {
      var min = parseInt(el.dataset.min, 10) || 12, max = parseInt(el.dataset.max, 10) || 19;
      var d1 = new Date(); d1.setDate(d1.getDate() + min);
      var d2 = new Date(); d2.setDate(d2.getDate() + max);
      var fmt = new Intl.DateTimeFormat(el.dataset.locale || 'fr', { day: 'numeric', month: 'long' });
      document.getElementById('ocn-pdp-edd-txt').textContent =
        el.dataset.tpl.replace('{from}', fmt.format(d1)).replace('{to}', fmt.format(d2));
      el.hidden = false;
    } catch(e){}
  })();

  // Vidéo fabrication : façade — la vidéo ne se charge qu'au clic
  document.querySelectorAll('.ocn-pdp__video-facade').forEach(function(btn){
    btn.addEventListener('click', function(){
      var v = document.createElement('video');
      v.src = btn.getAttribute('data-video');
      v.muted = true; v.defaultMuted = true; // aucun son, jamais
      v.volume = 0;
      v.autoplay = true; v.playsInline = true;
      v.loop = true;              // boucle silencieuse : juste l'image
      v.controls = false;         // aucun contrôle => impossible de remettre le son
      v.disablePictureInPicture = true;
      v.setAttribute('disableRemotePlayback', '');
      v.className = 'ocn-pdp__video-el';
      v.style.cursor = 'pointer';
      v.addEventListener('contextmenu', function(e){ e.preventDefault(); }); // pas de menu "afficher les contrôles"
      v.addEventListener('click', function(){ if (v.paused) { v.play(); } else { v.pause(); } }); // clic = pause / lecture
      v.addEventListener('volumechange', function(){ if (!v.muted || v.volume > 0) { v.muted = true; v.volume = 0; } }); // garde-fou : reste muet
      btn.replaceWith(v);
      v.play().catch(function(){});
    });
  });

  document.querySelectorAll('.ocn-pdp__mcard[data-hover-img]').forEach(function(card){
    var img = card.querySelector('img.ocn-pdp__mcard-img');
    var hover = card.getAttribute('data-hover-img');
    if (!img || !hover) return;
    var orig = img.getAttribute('src');
    card.addEventListener('mouseenter', function(){ img.setAttribute('src', hover); });
    card.addEventListener('mouseleave', function(){ img.setAttribute('src', orig); });
  });

  // Mobile : accordéons fermés par défaut (l'utilisateur les ouvre au clic)
  if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
    document.querySelectorAll('.ocn-pdp__acc[open]').forEach(function(d){ d.removeAttribute('open'); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recycle-combi"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.getElementById('ocn-rc');
  if (!root) return;
  let variants = [];
  try { variants = JSON.parse(document.getElementById('ocn-rc-variants').textContent); } catch(e){}
  const idInput = document.getElementById('ocn-rc-variant-id');
  const priceEl = document.getElementById('ocn-rc-price');
  const addPriceEl = document.getElementById('ocn-rc-add-price');
  const money = (c) => { try { return (c/100).toLocaleString('fr-FR',{minimumFractionDigits:2,maximumFractionDigits:2})+' €'; } catch(e){ return (c/100).toFixed(2)+' €'; } };

  let selected = [];
  root.querySelectorAll('.ocn-rc__option[data-option-index]').forEach((optEl, i) => {
    const active = optEl.querySelector('[data-value].is-active');
    if (active) selected[parseInt(optEl.dataset.optionIndex,10)] = active.dataset.value;
  });

  function findVariant(){ return variants.find(v => v.options.every((o,i) => o === selected[i])); }

  // Option vidéo payante (prestation ajoutée en ligne séparée)
  const vopt = root.querySelector('.ocn-rc__vopt');
  const videoVariant = vopt ? vopt.getAttribute('data-video-variant') : '';
  const videoPrice = vopt ? Math.round(parseFloat(vopt.getAttribute('data-video-price') || '0') * 100) : 0;
  let videoOn = false;

  function update(){
    const v = findVariant();
    let total = v ? v.price : (variants[0] ? variants[0].price : 0);
    if (videoOn) total += videoPrice;
    if (v && idInput) idInput.value = v.id;
    if (priceEl) priceEl.textContent = money(total);
    if (addPriceEl) addPriceEl.textContent = money(total);
    var sp = document.getElementById('ocn-rc-sticky-price'); if (sp) sp.textContent = money(total);
    renderRecap();
  }
  function renderRecap(){
    var rm=document.getElementById('ocn-rc-recap-model'), rl=document.getElementById('ocn-rc-recap-lens'), rp=document.getElementById('ocn-rc-recap-polar'), rd=document.getElementById('ocn-rc-recap-dot'), rt=document.getElementById('ocn-rc-recap-thumb');
    if(!rm) return;
    var mb=root.querySelector('.ocn-rc__model-btn.is-active');
    if(mb){ var mn=mb.querySelector('.ocn-rc__model-name'); rm.textContent=mn?mn.textContent:(mb.dataset.value||''); var mi=mb.querySelector('.ocn-rc__model-thumb img'); if(rt) rt.style.backgroundImage=mi?("url('"+mi.getAttribute('src')+"')"):''; }
    var lb=root.querySelector('.ocn-rc__chip-btn.is-active');
    if(lb){ if(rl) rl.textContent=lb.getAttribute('title')||lb.dataset.value||''; var chip=lb.querySelector('.ocn-rc__chip'); if(rd&&chip){ if(chip.classList.contains('ocn-rc__chip--clear')){ rd.style.background='#fff'; } else { rd.style.background=chip.style.background||chip.style.backgroundColor||''; } } } else if(rl){ rl.textContent=''; }
    var pb=root.querySelector('.ocn-rc__polar-btn.is-active');
    if(rp) rp.textContent= pb?(pb.getAttribute('title')||pb.dataset.value||''):'';
  }
  update();

  if (vopt) {
    vopt.querySelectorAll('.ocn-rc__vopt-card').forEach(function(card){
      card.addEventListener('click', function(){
        vopt.querySelectorAll('.ocn-rc__vopt-card').forEach(function(c){ c.classList.remove('is-active'); });
        card.classList.add('is-active');
        videoOn = card.getAttribute('data-video-choice') === 'yes';
        update();
      });
    });
  }

  root.querySelectorAll('.ocn-rc__option [data-value]').forEach(btn => {
    btn.addEventListener('click', () => {
      const oi = parseInt(btn.dataset.option, 10);
      selected[oi] = btn.dataset.value;
      btn.closest('.ocn-rc__values').querySelectorAll('[data-value]').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const lbl = root.querySelector('[data-selected-value="'+oi+'"]');
      if (lbl) lbl.textContent = btn.dataset.value;
      update();
    });
  });

  // Quantité
  const qty = document.getElementById('ocn-rc-qty');
  document.getElementById('ocn-rc-minus').addEventListener('click', () => { qty.value = Math.max(1, parseInt(qty.value||1,10)-1); });
  document.getElementById('ocn-rc-plus').addEventListener('click', () => { qty.value = parseInt(qty.value||1,10)+1; });

  function buildItems(){
    const v = findVariant();
    const vid = v ? v.id : (idInput ? idInput.value : null);
    const q = Math.max(1, parseInt(qty.value||1,10));
    if (!vid) return null;
    const items = [{ id: vid, quantity: q, properties: { 'Service': 'Recyclage de votre combinaison' } }];
    if (videoOn && videoVariant) {
      items.push({ id: videoVariant, quantity: 1, properties: { 'Prestation': 'Vidéo de la transformation' } });
    }
    return items;
  }
  function addToCart(redirect, btn){
    // Atelier en pause : aucun ajout au panier possible
    const rcAdd = document.getElementById('ocn-rc-add');
    if (rcAdd && rcAdd.dataset.paused === '1') return;
    const items = buildItems();
    if (!items) return;
    if (btn){ btn.classList.add('is-loading'); }
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items: items }) })
      .then(r => r.json()).then(() => { window.location.href = redirect; })
      .catch(() => { if (btn) btn.classList.remove('is-loading'); });
  }
  document.getElementById('ocn-rc-add').addEventListener('click', function(){ addToCart('/cart', this); });
  const rcBuy = document.getElementById('ocn-rc-buynow');
  if (rcBuy) rcBuy.addEventListener('click', function(){ this.textContent=this.dataset.redirectLabel||'Redirection…'; addToCart('/checkout', this); });

  // Impression fiche colis
  const printBtn = document.getElementById('ocn-rc-print');
  if (printBtn) printBtn.addEventListener('click', () => {
    const card = document.getElementById('ocn-rc-card');
    const w = window.open('', '_blank', 'width=620,height=800');
    const ptitle = (printBtn.dataset.printTitle || 'Fiche colis OCENEO').replace(/</g,'&lt;');
    w.document.write('<html><head><title>'+ptitle+'</title><style>body{font-family:Arial,Helvetica,sans-serif;padding:32px;color:#15171A;}h1{font-size:16px;text-transform:uppercase;letter-spacing:.04em;}li{list-style:none;display:flex;gap:12px;padding:10px 0;border-bottom:1px solid #ddd;}li span:first-child{color:#777;min-width:140px;}ul{padding:0;}address{font-style:normal;background:#15171A;color:#fff;padding:14px;border-radius:8px;font-weight:bold;}</style></head><body>'+card.innerHTML+'</body></html>');
    w.document.close(); w.focus(); setTimeout(function(){ w.print(); }, 250);
  });

  // Barre d'achat sticky
  const sticky = document.getElementById('ocn-rc-sticky');
  const purchase = root.querySelector('.ocn-rc__purchase');
  if (sticky && purchase && 'IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => { sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    obs.observe(purchase);
  }
  const sBuy = document.getElementById('ocn-rc-sticky-buy');
  if (sBuy) sBuy.addEventListener('click', () => addToCart('/cart', sBuy));

  // Bouton play sur le poster : lance la vidéo puis se masque
  const vEl = root.querySelector('.ocn-rc__video-el');
  const vPlay = root.querySelector('.ocn-rc__video-play');
  if (vEl && vPlay) {
    vPlay.addEventListener('click', function(){ var p = vEl.play(); if (p && p.catch) p.catch(function(){}); });
    vEl.addEventListener('play', function(){ vPlay.classList.add('is-hidden'); });
    vEl.addEventListener('ended', function(){ vPlay.classList.remove('is-hidden'); });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
